import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWindshieldPassenger = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 350 350",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#WindshieldPassenger_svg__a)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#WindshieldPassenger_svg__b)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M175 350c96.65 0 175-78.35 175-175S271.65 0 175 0 0 78.35 0 175s78.35 175 175 175"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M34.87 133.13a1572 1572 0 0 0-18.12-32.46 176 176 0 0 1 37.16-51.8c17.19 2.88 66.9 10.8 99 19.79 0 0 31.28 9.45 34.28 10.91.89.07 1.27-.5 1.27-.5A323 323 0 0 1 210 88.15c2.94 1.37 48.3 34.6 93.87 74.3 24.87 12.46 45.67 24.27 45.93 24.41C343.69 277.98 267.86 350 175.2 350q-2.6 0-5.17-.08a174.6 174.6 0 0 1-126.26-59.4c.11-.02 2.04-.43 11.58-2.27 9.86-1.9 14.36-.11 18.1 2 3.72 2.1 30.05 23.98 30.1 24.02a90 90 0 0 0-3.87-23.93C92.2 265.64 48 157.06 34.87 133.13m172.1 182.42c50.81-13.4 101.53-46.36 120.39-98.96 12.83-35.78-14.37-46.12-23.75-51.68 0 0-74.68-63.28-94.4-75.06L36.48 96.94s12.2 19.08 21.39 37.6c9.19 18.5 72.76 147.57 76.6 150.76 3.82 3.19 21.7 43.66 72.5 30.25"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#1b1a1c",
					d: "M59.92 200.85c-3.8 4.47-5.63 16.15-6.49 33.86-.7 14.24-1.53 17.84-1.83 18.7-7.17-9.17-21.25-23.53-23.83-25.3-3.04-2.1-18.67 1.24-18.93 1.3A175 175 0 0 1 .2 175a174 174 0 0 1 14.4-69.6c.15.27 11.98 21.32 20.55 37.69 3.95 7.55 14.08 31.6 24.77 57.76"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "m57.69 45.33-1.4 1.29z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M8.84 229.4c.26-.05 15.9-3.38 18.93-1.3 2.58 1.78 16.66 16.14 23.83 25.3a46 46 0 0 1 3.17 4.48 10 10 0 0 1 1.58 5.47c-.15 5.04-4.72 9.05-7.51 13.24-3.73 5.58-9.9 4.88-12.34 5.1a175 175 0 0 1-27.66-52.28"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3c3c3b",
					d: "M14.6 105.4q1.04-2.39 2.15-4.73c.13.22 5.17 8.84 18.12 32.46C48 157.06 92.2 265.63 99.67 290.34a90 90 0 0 1 3.88 23.93c-.05-.04-26.38-21.92-30.1-24.02-3.74-2.11-8.24-3.9-18.1-2a757 757 0 0 0-11.58 2.27 177 177 0 0 1-7.27-8.82c2.43-.23 8.6.47 12.34-5.11 2.8-4.19 7.36-8.2 7.5-13.24.06-1.7-.4-3.5-1.57-5.47a46 46 0 0 0-3.17-4.47c.3-.86 1.14-4.46 1.83-18.7.86-17.7 2.68-29.39 6.49-33.86-10.7-26.16-20.82-50.2-24.78-57.76A1724 1724 0 0 0 14.6 105.4"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3c3c3b",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M134.46 285.3c-3.83-3.2-67.4-132.26-76.6-150.77-9.18-18.5-21.38-37.6-21.38-37.6l172.73-7.08c19.72 11.78 94.4 75.07 94.4 75.07 9.38 5.55 36.58 15.89 23.75 51.68-18.86 52.6-69.58 85.55-120.39 98.95-50.8 13.4-68.68-27.06-72.5-30.25m33.48-11.38c28.92-9.57 127.5-56.67 130.98-104.94.67-9.3-74.68-67.6-86.04-73.85-12.38-.38-23.75 1.4-23.75 1.4l7.54 8.05s2.42 2.43-3.07 2.94-8.04.86-8.04.86 2.44 3.25-.2 3.59c-2.62.33-4.44.67-8.47-2.4-5.79.72-10 1.4-11.77 1.63-1.77.24-5.55 1.68-10.92-2.15s-14.6-9.58-14.6-9.58-77.17 5.75-81.38 5.75-11.49 0-2.3 15.13 69.9 130.98 73.53 137.68c3.64 6.7 9.58 25.47 38.5 15.9z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#0bbbef",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M55.72 120.35c-9.2-15.13-1.92-15.13 2.3-15.13 4.2 0 81.38-5.75 81.38-5.75s9.24 5.75 14.6 9.58 9.14 2.4 10.91 2.15c1.77-.24 5.99-.9 11.78-1.63 4.02 3.07 5.84 2.73 8.47 2.4s.2-3.6.2-3.6 2.55-.34 8.04-.86c5.48-.5 3.06-2.93 3.06-2.93l-7.53-8.04s11.36-1.8 23.74-1.4c11.37 6.25 86.72 64.54 86.04 73.84-3.47 48.27-102.06 95.37-130.97 104.94-28.92 9.57-34.86-9.2-38.5-15.9-3.63-6.7-64.33-122.55-73.53-137.68z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "m54.82 47.99 1.47-1.37q-.74.68-1.46 1.37zM57.84 45.19q0 0 0 0l-.15.14z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "m56.3 46.62 1.39-1.3.16-.13c13.07.9 61.87 7.2 88.8 13.83 26.94 6.64 41.81 20.04 41.81 20.04s-.38.58-1.27.52c-1.8-.89-7.36-2.4-10.16-3.47-.95-.73-1.6-1.2-1.6-1.2-3.49-2.55-11.15-7.32-24.12-10.72 0 0-36.57-11.47-96.48-16.2z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "m152.82 64.6 1.69 4.54 22.52 6.97s-8.44-7.45-24.21-11.51z"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 2,
					d: "M349.47 186.17c-.25-.14-20.06-12.4-44.93-24.86-45.57-39.7-90.92-72.94-93.86-74.31a324 324 0 0 0-21.54-9.1s-14.87-13.4-41.8-20.04C120.4 51.22 71.67 45.5 58.6 44.59"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3c3c3b",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "m102.83 326.91-45.18-38.66s8.82-3.19 15.8 2c6.96 5.18 30.1 24.02 30.1 24.02s-.21 9.66-.72 12.64"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M36.65 281.7c2.44-.23 8.61.47 12.34-5.11 2.8-4.19 7.37-8.2 7.51-13.24.05-1.7-.4-3.5-1.57-5.47a46 46 0 0 0-3.18-4.47c-7.17-9.17-21.24-23.53-23.82-25.3-3.04-2.1-18.67 1.24-18.93 1.3m47.5 33.94c-1.4 7.57-18.8 9.76-26.27 9.47"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M16.9 100.67c.13.22 5.17 8.84 18.12 32.46 13.13 23.93 57.34 132.5 64.81 157.21a90 90 0 0 1 3.88 23.93c-.05-.04-26.38-21.92-30.11-24.02-3.74-2.11-8.24-3.9-18.1-2a757 757 0 0 0-11.58 2.27"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M36.65 281.7c2.44-.23 8.61.47 12.34-5.11 2.8-4.19 7.37-8.2 7.51-13.24.05-1.7-.4-3.5-1.57-5.47a46 46 0 0 0-3.18-4.47c.3-.86 1.14-4.46 1.84-18.7.86-17.71 2.68-29.39 6.48-33.86M14.76 105.4c.14.26 11.98 21.3 20.54 37.68 3.95 7.55 14.08 31.6 24.77 57.76 13.56 33.17 28.02 69.73 31.9 80.3m0 0c6.97 18.9 7.1 22.02 8.14 30.15-1.05-8.13-1.17-11.26-8.13-30.15M39.78 285.64l36.88-7.08z"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: .5,
					d: "m135.74 286.83-7.43 2.84-28.63-.77M170.65 315.85l-2.51 23.7 1.92 10.45M101.13 333.59s1.11-2.74 1.67-6.45"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M154.51 69.14c-13.49-3.58-58.99-14.45-100.6-20.28"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M117.98 101.55s89.61 127.38 100.37 148.49c-2.3 1.6-16.07 8.7-23.22 12-19.84-39.38-101.78-158.68-101.78-158.68zM189.2 264.73c-2.09 1.1-6.88 3.01-10.06 4.35-11-24.8-39.54-81.1-39.54-81.1s24.32 32.36 49.6 76.75M131.17 100.59c-2.48.2-5.09.37-7.06.52 10.08 11.13 48.28 62.25 48.28 62.25s-16.62-28.73-41.22-62.78"
				}),
				/* @__PURE__ */ _jsxs("g", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					opacity: .5,
					children: [
						/* @__PURE__ */ _jsx("path", { d: "M291.9 159.34s-15.33-7.3-20.91-2.9c-8.8 6.94-25.61 15.65-30.77 26.7-1.72 3.69 0 17.83 0 17.83l-37.82 21.76" }),
						/* @__PURE__ */ _jsx("path", { d: "M270.99 156.44c-.34-3.75-1.7-7.97-8.87-7.25s-28.44 13.41-38.34 30.39c-1.32 2.27-9.13 17.32 1.33 22.03 6.24 2.82 14.6-6.06 14.6-6.06" }),
						/* @__PURE__ */ _jsx("path", { d: "M266.52 159.66c-.28-2.44-5.19-2.56-17.1 7.44s-22.5 24.9-19.1 29.07" }),
						/* @__PURE__ */ _jsx("path", {
							strokeWidth: .5,
							d: "M262.12 149.19c1.27.92 3.62 4.93 2.45 8.94M226.33 175.73s3.27 5.47 7.99 7.9"
						}),
						/* @__PURE__ */ _jsx("path", { d: "M230.98 189.29c3.07-.14 6.88 1.27 8.58 3.85" })
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M9.76 120.15a5 5 0 0 1-5-5V71.32a5 5 0 0 1 5-5h40.4a5 5 0 1 1 0 10h-35.4v38.83a5 5 0 0 1-5 5"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#1b1a1c",
					d: "M50.15 66.32a5 5 0 1 1 0 10H14.76v38.83a5 5 0 1 1-10 0V71.32a5 5 0 0 1 5-5zm0-2H9.76a7 7 0 0 0-7 7v43.83a7 7 0 0 0 14 0V78.32h33.4a7 7 0 0 0 0-14"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M340.24 120.15a5 5 0 0 1-5-5V76.32h-35.4a5 5 0 1 1 0-10h40.4a5 5 0 0 1 5 5v43.83a5 5 0 0 1-5 5"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#1b1a1c",
					d: "M340.24 66.32a5 5 0 0 1 5 5v43.83a5 5 0 1 1-10 0V76.32h-35.4a5 5 0 1 1 0-10zm0-2h-40.4a7 7 0 0 0 0 14h33.4v36.83a7 7 0 0 0 14 0V71.32a7 7 0 0 0-7-7"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M50.15 308.61H9.76a5 5 0 0 1-5-5v-43.83a5 5 0 1 1 10 0v38.83h35.4a5 5 0 1 1 0 10"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#1b1a1c",
					d: "M9.76 254.78a5 5 0 0 1 5 5v38.83h35.4a5 5 0 1 1 0 10H9.75a5 5 0 0 1-5-5v-43.83a5 5 0 0 1 5-5m0-2a7 7 0 0 0-7 7v43.83a7 7 0 0 0 7 7h40.4a7 7 0 0 0 0-14h-33.4v-36.83a7 7 0 0 0-7-7"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M340.24 308.61h-40.4a5 5 0 1 1 0-10h35.4v-38.83a5 5 0 1 1 10 0v43.83a5 5 0 0 1-5 5"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#1b1a1c",
					d: "M340.24 254.78a5 5 0 0 1 5 5v43.83a5 5 0 0 1-5 5h-40.4a5 5 0 1 1 0-10h35.4v-38.83a5 5 0 0 1 5-5m0-2a7 7 0 0 0-7 7v36.83h-33.4a7 7 0 0 0 0 14h40.4a7 7 0 0 0 7-7v-43.83a7 7 0 0 0-7-7"
				})
			]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "WindshieldPassenger_svg__a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h350v350H0z"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "WindshieldPassenger_svg__b",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h350v350H0z"
		})
	})] })]
});
export default SvgWindshieldPassenger;
